import { ActionIcon, Tooltip } from "@mantine/core";
import { IconPin, IconPinFilled } from "@tabler/icons-react";
import { useLanguage } from "../../stores/LanguageStore";
import { useUIStore } from "../../stores/UIStore";

const NavbarLocker = ({ closed }) => {
  const lang = useLanguage((s) => s.language);

  const pinnedNavbar = useUIStore((s) => s.pinnedNavbar);
  const setPinnedNavbar = useUIStore((s) => s.setPinnedNavbar);
  return (
    <Tooltip label={pinnedNavbar ? lang.navbar.unpin : lang.navbar.pin}>
      <ActionIcon
        variant={pinnedNavbar ? "light" : "subtle"}
        size={"md"}
        pos={"absolute"}
        top={0}
        right={closed ? -32 : 0}
        onClick={() => setPinnedNavbar(!pinnedNavbar)}
        style={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        {pinnedNavbar ? <IconPinFilled size={16} /> : <IconPin size={16} />}
      </ActionIcon>
    </Tooltip>
  );
};

export default NavbarLocker;
